import * as R from 'ramda';

export default (s) => R.head(s.split(';'));
